var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 15.4167C12.9915 15.4167 15.4166 12.9916 15.4166 10C15.4166 7.0085 12.9915 4.58337 9.99992 4.58337C7.00838 4.58337 4.58325 7.0085 4.58325 10C4.58325 12.9916 7.00838 15.4167 9.99992 15.4167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9501 15.95L15.8417 15.8416M15.8417 4.15829L15.9501 4.04996L15.8417 4.15829ZM4.05008 15.95L4.15841 15.8416L4.05008 15.95ZM10.0001 1.73329V1.66663V1.73329ZM10.0001 18.3333V18.2666V18.3333ZM1.73341 9.99996H1.66675H1.73341ZM18.3334 9.99996H18.2667H18.3334ZM4.15841 4.15829L4.05008 4.04996L4.15841 4.15829Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.fbb7e4b5f6a264b01ddbd2f108922a83.svg";
export { ForwardRef as ReactComponent };